import { TableHeadersConfig } from '../../utils/utils';

export const usersTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Full Name',
    sortingKey: 'firstName',
  },
  {
    title: 'Username',
    sortingKey: 'userName',
  },
  {
    title: 'Email',
    sortingKey: 'email',
  },
  {
    title: 'Telephone',
    sortingKey: 'telephoneNumber',
  },
  {
    title: 'Date of Birth',
    sortingKey: 'dateOfBirth',
  },
  {
    title: 'Gender',
    sortingKey: 'gender',
  },
  {
    title: 'Address',
    sortingKey: 'address',
  },
  {
    title: 'City',
    sortingKey: 'city',
  },
  {
    title: 'Province',
    sortingKey: 'province',
  },
  {
    title: 'Postal code',
    sortingKey: 'CAP',
  },
  {
    title: 'Country',
    sortingKey: 'country',
  },
  {
    title: 'Action',
  }
];



// WEBPACK FOOTER //
// ./src/pages/users/usersTableConfig.ts